import { RowNode } from "ag-grid";

export class AgPostSort {

  static nullFixPostSort(fields: string[]) {

    let postSort = (rowNodes: RowNode[]) => {
      let checkFields: string[] = fields;
      
      let isNull = (node: RowNode) => {
        let result: boolean = true;
        for (let field of checkFields) {
          if (node.data[field]) {
            result = false;
            break;
          }
        }
        return result;
      };
      let nullNodes: RowNode[] = [];

      for (let i = 0 ; i < rowNodes.length ; i++) {
        let node: RowNode = rowNodes[i];
        let result: boolean = (isNull(node));
        if (result) {
          nullNodes.push(rowNodes.splice(i, 1)[0]);
          i--;
        }
      }
      for (let nullNode of nullNodes) rowNodes.push(nullNode);      
    };

    return postSort;
  }


}


// WEBPACK FOOTER //
// ./src/app/components/ag-grid/ag-post-sort.ts